<template>
  <div id="compreSportsMeet_bigSports" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div
      class="bigSportsList"
      ref="tableParentDom"
      v-show="bigSportsApiList && bigSportsApiList.length > 0"
    >
      <span
        class="sportsItem"
        v-for="item in bigSportsApiList"
        :key="item.id"
        @click="goDetail(item)"
      >
        <span class="sportsItem_absBg"></span>
        <span class="sportsItem_abs">
          <span class="sportsItem_icon">
            <img
              :class="isSportsIconFillBg ? 'fillBg' : ''"
              :src="
                item.sid === 'ASG2026'
                  ? `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/ASG2026/${item.id}.png`
                  : `/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/sportsIcon/${item.id}.png`
              "
            />
          </span>
          <span class="sportsItem_name" v-text="item.CN"></span>
        </span>
      </span>
    </div>
    <NOT_DATA v-if="noData" :className="'relativePtb30'"></NOT_DATA>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
  </div>
</template>

<script>
import { https_sportsList } from '@api/platfrom_compreSportsMeet_api'
import NOT_DATA from '@components/base/NO_DATA.vue'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_bigSports',
  mixins: [cup_base_data_mixin],
  components: {
    NOT_DATA,
    BackTop,
    marathon_select_opt,
  },
  data() {
    return {
      detailPathName: 'CSMeetSportsDetailScheduleDate',
      bigSportsApiList_orgin: null,
      bigSportsApiList: null,
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入项目名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      selectOptData: {
        configArr: [],
        selectOpt_list: [],
      },
      curInputVal: '',
      scrollDomById: 'containerFull_body',
      showBackTop: false,
    }
  },
  created() {
    this.init()
    console.debug(this.bigSportsList)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noData() {
      console.log(
        this.bigSportsApiList,
        'this.bigSportsApiListthis.bigSportsApiList'
      )
      return this.bigSportsApiList && this.bigSportsApiList.length == 0
    },
    isSportsIconFillBg() {
      if (this.axiosBaseUrl && ['/sog'].includes(this.axiosBaseUrl)) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.getBigSportsList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug(
        'inputVal:',
        inputVal,
        this.bigSportsApiList_orgin,
        this.bigSportsApiList
      )
      this.curInputVal = inputVal

      this.bigSportsApiList = this.bigSportsApiList_orgin

      if (inputVal) {
        const bigSportsApiList = []
        this.bigSportsApiList.forEach((item) => {
          console.debug(item.CN, inputVal, item.CN.indexOf(inputVal) > -1)
          if (item.CN.indexOf(inputVal) > -1) {
            bigSportsApiList.push(item)
          }
        })
        this.bigSportsApiList = bigSportsApiList
      } else {
        this.bigSportsApiList = this.bigSportsApiList_orgin
      }
    },
    scrollListenerEvent() {
      const scrollTop = this.scrollAreaDom.scrollTop
      const scrollHeight = this.scrollAreaDom.scrollHeight
      const parentHeightPx = this.scrollAreaDom.offsetHeight
      let direction = this.DIRECTION_ENUM.DOWN
      if (this.beforeScrollTop > scrollTop) {
        direction = this.DIRECTION_ENUM.UP
      }
      // 通过滚动方向判断是触底还是触顶
      // console.debug(
      //   'direction:',
      //   direction,
      //   scrollTop,
      //   parentHeightPx,
      //   scrollHeight,
      //   this.isScrollBottom,
      //   this.matchTotal,
      //   this.curMatchListNum
      // )
      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      if (direction == this.DIRECTION_ENUM.DOWN) {
        // 滚动触底
        if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
          console.debug('滚动触底')
        }
      } else {
        // 滚动到顶部
        if (scrollTop <= this.threshold) {
          console.debug('滚动到顶部')
        }
      }
      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      // console.debug(
      //   'this.parentWidthPx:',
      //   this.$refs.tableParentDom.scrollHeight
      // )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    goDetail(item) {
      if (this.detailPathName) {
        this.pageJump(
          this.$router,
          `${this.detailPathName}_${this.currCid}`,
          {
            cid: this.currCid,
            sid: this.currSid,
          },
          item
        )
      }
      let currSportsDetail = {
        sportsId: item.id,
        eventId: '',
        matchId: '',
        sportsName: item.CN,
        eventName: '',
      }
      console.debug('bigSports:', currSportsDetail)
      this.$localStorage.setItem(
        'mixtmt_platfromV4_currSportsDetail',
        JSON.stringify(currSportsDetail)
      )
    },
    async getBigSportsList() {
      await https_sportsList(this.axiosBaseUrl, this.$axios, {
        sid: this.currSid,
      })
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.bigSportsApiList = res.data.map((item) => {
                return {
                  id: item.disciplineCode,
                  CN: item.disciplineName,
                  sid: item.seasonCode,
                }
              })
              this.bigSportsApiList_orgin = JSON.parse(
                JSON.stringify(this.bigSportsApiList)
              )
              this.initScroll()
            } else {
              this.bigSportsApiList = []
              console.debug('暂无数据')
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#compreSportsMeet_bigSports {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }
  .bigSportsList {
    transform-style: preserve-3d;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    padding: 3.472vw 0;
    .sportsItem {
      position: relative;
      width: 11.805vw;
      height: 12.85vw;
      margin: 0 calc((100% - (6 * 11.805vw)) / 5) 2.43vw 0;

      &:nth-child(6n) {
        margin: 0 0 2.43vw 0;
      }
      .sportsItem_absBg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        width: 100%;
        height: 0;
        /* transform-origin: 50% -50%; */
        border-radius: 1.388vw;
        background-color: var(--mixtmt_greyColor8);
      }
      .sportsItem_abs {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        .sportsItem_icon {
          width: 8.75vw;
          height: 8.75vw;
          overflow: hidden;
          & .fillBg {
            background-color: var(--mixtmt_theme_sportsItemBg);
            border-radius: 50%;
          }
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            transform: rotateY(0);
            transition: transform 0.3s linear;
          }
        }
        .sportsItem_name {
          width: 100%;
          height: 2.5vw;
          line-height: 2.5vw;
          color: var(--mixtmt_greyColor2);
          font-weight: bold;
          text-align: center;
        }
      }
    }
  }
}
.mixtmt_pc #compreSportsMeet_bigSports {
  .bigSportsList {
    .sportsItem {
      &:hover {
        cursor: pointer;
        .sportsItem_absBg {
          display: block;
          height: 100%;
          border: 1px solid var(--mixtmt_mainColor0);
        }
        .sportsItem_abs {
          .sportsItem_icon {
            img {
              transform: rotateY(180deg);
            }
          }
        }
      }
    }
  }
}
</style>
